import { useLang } from "../context/LanguageContext";
import { legalDocs, legalLabels } from "../i18n/legal";
import { Reveal } from "./Reveal";

export default function LegalPage({ docKey }) {
  const { lang } = useLang();
  const labels = legalLabels[lang];
  const doc = legalDocs[docKey][lang];

  return (
    <section className="pt-40 pb-24 lg:pt-48" data-testid={`legal-page-${docKey}`}>
      <div className="absolute inset-0 hud-lines opacity-30 pointer-events-none" aria-hidden="true" />
      <div className="relative max-w-4xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="font-mono text-[11px] font-bold tracking-[0.3em] uppercase text-sovereign flex items-center gap-3">
            <span className="w-8 h-px bg-sovereign/60" aria-hidden="true" />
            {labels.eyebrow}
          </p>
        </Reveal>
        <h1 className="mt-6 font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl" data-testid={`legal-title-${docKey}`}>
          {doc.title}
        </h1>
        <p className="mt-3 font-mono text-[11px] tracking-[0.2em] uppercase text-slate-500">{labels.updated}</p>

        <Reveal delay={0.1}>
          <p className="mt-10 text-base text-slate-300 leading-relaxed border-l-2 border-sovereign/40 pl-5">{doc.intro}</p>
        </Reveal>

        <div className="mt-10 space-y-10 pb-10">
          {doc.sections.map((s, i) => (
            <Reveal key={s.h} delay={Math.min(i * 0.03, 0.2)}>
              <div data-testid={`legal-section-${i}`}>
                <h2 className="font-display text-lg sm:text-xl font-bold text-slate-100">{s.h}</h2>
                <div className="mt-3 space-y-3">
                  {s.ps.map((p, j) => (
                    <p key={j} className="text-sm sm:text-base text-slate-400 leading-relaxed">{p}</p>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
